/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).ready(function() {
  if ($("#refreshing_prices_please_wait").length > 0) {
    const refresh_method = function() {
      const ajaxConfig = { 
        url: $("#refreshing_prices_please_wait").data("url"),
        dataType: "json",
        success(data) {
          if (data.location) {
            return window.location.replace(data.location);
          }
        }
      };

      return $.ajax(ajaxConfig); 
    };
        
    return setTimeout(refresh_method, 2000);
  }
});